/**
 * @param {React.ReactNode} children - Elementos hijos (inputs, select, etc.) que se renderizan dentro del formulario.
 * @param {Function} onSubmit - Función que se ejecuta cuando se envía el formulario.
 * @param {string} texto - Texto del botón de envío.
 * @param {string} [type="save"] - Tipo del botón de envío (por defecto es "save").
 * @param {boolean} [isSubmitting=false] - Indica si el formulario está en proceso de envío, deshabilitando el botón.
 */

import Button from '../common/Button'
const Form = ({ children, onSubmit, texto, type = "save", isSubmitting = false }) => {
  const handleSubmit = async (e) => {
    e.preventDefault()
    await onSubmit(e) // Llamamos a la función onSubmit proporcionada por el padre
  }

  return (
    <form onSubmit={handleSubmit}>
      {children} {/* Renderiza los Input pasados como hijos */}
      <div className='text-end'>
        <Button texto={isSubmitting ? "Procesando..." : texto} type={type} disabled={isSubmitting} />
      </div>
    </form>
  )
}

export default Form

